// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoErrorFilledSvg from "@fishx/icons-svg/es/asn/PtoErrorFilled";
import FishxIcon from '../components/FishxIcon';

var PtoErrorFilled = function PtoErrorFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoErrorFilledSvg
  }));
};

PtoErrorFilled.displayName = 'PtoErrorFilled';
export default React.forwardRef(PtoErrorFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoErrorFilled.js
// module id = 3902
// module chunks = 0